export const SEARCH_DOCTORS_REQUEST = "SEARCH_DOCTORS_REQUEST"
export const SEARCH_DOCTORS_SUCCESS = "SEARCH_DOCTORS_SUCCESS"
export const SEARCH_DOCTORS = "SEARCH_DOCTORS"
export const SET_SEARCHED_DOCTOR_LIST = "SET_SEARCHED_DOCTOR_LIST"
export const APPEND_DOCTOR_LIST = "APPEND_DOCTOR_LIST"
export const RESET_DOCTOR_LIST = 'RESET_DOCTOR_LIST'
export const DOCTOR_PROFESSION = "Médecin"
